import { Checkbox, ListItemText, MenuItem } from '@mui/material';
import React from 'react';
import { IoIosArrowDown } from 'react-icons/io';
import { useTranslation } from 'react-i18next';
import { StyledSelect } from './StyledComponents';
import Divider from '@mui/material/Divider';


const CustomSelectShiftReport = ({
   className = '',
   name,
   id,
   multiple = false,
   value = multiple ? [] : '',
   onChange = () => { },
   options,
   dataType,
   defaultValue,
   readOnly,
   position,
   disabledUserIds
}) => {
   const { t } = useTranslation();

   const getValue = (option) => {
      switch (dataType) {
         case 'leaveType':
            return option.leaveTypeId;
         case 'userGroup':
            return option.groupCode;
         case 'shift':
            return option.shiftId;
         case 'country':
            return option.alpha3Code;
         case 'administratorRights':
            return option.roleName;
         case 'company':
            return option.companyId;
         case 'dropDownShowTime':
            return option.showTimeID;
         case 'userType':
            return option.value;
         case 'user':
            return option.userId;
         case 'group':
            return option.id;
         case 'department':
            return option.departmentPrefix;
         case 'device':
            return option.deviceId;
         case 'selecStatusLeave':
            return option.statusLeaveId;
         default:
            return option.value;
      }
   };

   const getLabel = (option) => {
      switch (dataType) {
         case 'leaveType':
            return option.leaveTypeName;
         case 'userGroup':
            return option.description;
         case "shift":
            if (!option?.shiftName) return "";

            const name = option.shiftName.toUpperCase();

            if (name === "DEFAULT") return t("common.default");
            if (name === "ALL SHIFT")
               return t("common.all-shifts");

            return option.shiftName;
         case 'country':
            return option.countryName;
         case 'administratorRights':
            return t(`roles.${option.remark}`);
         case 'company':
            return option.companyName;
         case 'dropDownShowTime':
            return option.description;
         case 'user':
            return option.fullName;
         case 'group':
            return option.groupName;
         case 'department':
            return option.departmentName;
         case 'device':
            if (!option?.description) return "";

            const nameDevice = option.description.toUpperCase();

            if (nameDevice === "ALL DEVICE") return t("common.all-device");

            return option.description;
         case 'selecStatusLeave':
            return option.statusName;
         default:
            return option.label;
      }
   };

   const handleChange = (event) => {
      const { value } = event.target;


      if (multiple) {
         // When multiple selection is enabled, pass the array of selected values
         onChange({
            target: {
               name, // Include the 'name' from props
               value: typeof value === 'string' ? value.split(',') : value, // Handle multiple selection
            },
         });
      } else {
         // Single selection, pass the value directly
         onChange({
            target: {
               name, // Include the 'name' from props
               value, // Single value, not an array
            },
         });
      }
   };



   // const validValue = options?.some(option => getValue(option) === value) ? value : '';
   const validValue = multiple
      ? Array.isArray(value)
         ? value.filter((val) => options?.some((option) => getValue(option) === val))
         : [] // If it's not an array, default to an empty array
      : options?.some((option) => getValue(option) === value)
         ? value
         : '';

   return (
      <StyledSelect
         multiple={multiple}
         IconComponent={(props) => (
            <IoIosArrowDown {...props} size={16} />
         )}
         renderValue={(selected) => {
            const toLabels = (arr) =>
               arr
                  .map((val) => {
                     const found = options.find((o) => getValue(o) === val);
                     return found ? getLabel(found) : "";
                  })
                  .filter(Boolean);

            if (Array.isArray(selected)) {
               // ✅ TRƯỜNG HỢP CHỌN "ALL SHIFT"
               if (
                  dataType === "shift" &&
                  selected.includes(0) // shiftId = 0 là ALL
               ) {
                  return (
                     <span
                        title={t("common.all-shifts")}
                        className="block overflow-hidden text-ellipsis whitespace-nowrap"
                     >
                        {t("common.all-shifts")}
                     </span>
                  );
               }

               const labels = toLabels(selected);
               if (labels.length === 0) return "";

               const MAX_ITEMS = 4;
               const fullText = labels.join(", ");
               const display =
                  labels.length > MAX_ITEMS
                     ? `${labels.slice(0, MAX_ITEMS).join(", ")} +${labels.length - MAX_ITEMS} ...`
                     : fullText;

               return (
                  <span
                     title={fullText}
                     className="block overflow-hidden text-ellipsis whitespace-nowrap"
                  >
                     {display}
                  </span>
               );
            }

            // Single
            const found = options.find((o) => getValue(o) === selected);
            const label = found ? getLabel(found) : selected;

            return (
               <span
                  title={label}
                  className="block overflow-hidden text-ellipsis whitespace-nowrap"
               >
                  {label}
               </span>
            );
         }}

         name={name}
         id={id}
         value={validValue}
         onChange={handleChange}
         defaultValue={defaultValue || null}
         readOnly={readOnly}
         className={`form-control !bg-white ${className}`}
         sx={{
            "&&": {
               borderRadius: "8px",
            },
            "& .MuiInputBase-root, & .MuiOutlinedInput-root": {
               borderRadius: "8px",
            },
            "& .MuiOutlinedInput-notchedOutline": {
               borderRadius: "8px",
            },
            // Chừa khoảng trống cho icon mũi tên để text không đè
            "& .MuiSelect-select": {
               overflow: "hidden",
               whiteSpace: "nowrap",
               textOverflow: "ellipsis",
               paddingRight: "2.5rem !important",
            },
            // Đẩy icon sang phải 1 chút cho thoáng
            "& .MuiSelect-icon": {
               right: "8px",
               color: "#374151",
            },
            // Bỏ hiệu ứng hover/focus (override StyledSelect)
            "&:hover fieldset": {
               border: "1px solid #E5E7EB !important",
               boxShadow: "none !important",
            },
            "&.Mui-focused fieldset, & .MuiOutlinedInput-root.Mui-focused fieldset": {
               border: "1px solid #E5E7EB !important",
               boxShadow: "none !important",
            },
            "&.Mui-focused, & .MuiOutlinedInput-root.Mui-focused": {
               boxShadow: "none !important",
            },
         }}
         MenuProps={{
            disablePortal: true,
            anchorOrigin: {
               vertical: position === 'top' ? 'top' : 'bottom',
               horizontal: 'left',
            },
            transformOrigin: {
               vertical: position === 'top' ? 'bottom' : 'top',
               horizontal: 'left',
            },
            PaperProps: {
               style: {
                  maxHeight: 200,
               },
            },
            disableAutoFocusItem: true,
         }}
      >
         {options?.map((option, index) => (
            <MenuItem
               key={index}
               value={getValue(option)}
               disableRipple
               sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                  pl: 1,
                  pr: 1,

                  // ❗ XÓA MÀU CHỌN / MÀU FOCUS / MÀU HOVER CỦA MUI
                  "&:hover, &.Mui-focused, &.Mui-selected, &.Mui-selected:hover, &.Mui-focusVisible": {
                     backgroundColor: "transparent !important",
                  },

                  // ❗ XÓA LINE (border) CỦA DÒNG "ALL" (shift = 0 hoặc device = 0)
                  borderBottom:
                     (dataType === "shift" || dataType === "device") &&
                        getValue(option) === 0
                        ? "none"
                        : "none",

                  // ❗ Nếu có sticky thì vẫn giữ layout
                  position:
                     (dataType === "shift" || dataType === "device") &&
                        getValue(option) === 0
                        ? "undefined"
                        : undefined,
                  top:
                     (dataType === "shift" || dataType === "device") &&
                        getValue(option) === 0
                        ? 0
                        : undefined,
                  zIndex:
                     (dataType === "shift" || dataType === "device") &&
                        getValue(option) === 0
                        ? 0   // ❗ KHÔNG để > 0
                        : undefined,
                  backgroundColor: "#fff",

               }}
            >
               {multiple && (
                  <Checkbox
                     checked={
                        Array.isArray(value) && value.includes(getValue(option))
                     }
                     sx={{
                        p: 0,
                        width: 20,
                        height: 30,
                        mr: 1.5,
                     }}
                  />
               )}
               <ListItemText primary={getLabel(option)} />
            </MenuItem>
         ))}
      </StyledSelect>
   );
};

export default CustomSelectShiftReport;
